import { ClipboardListIcon, FolderIcon, XIcon } from "lucide-react";
import * as React from "react";
import { Link, useLocation } from "react-router";
import { Button } from "@/components/ui/button";
import clsx from "clsx";

interface FavoriteItemProps {
  fsEntryId: string;
  folderName: string;
  onRemove: (fsEntryId: string) => void;
  isRemoving: boolean;
  type: "snapshot" | "folder";
  linkPath?: string;
}

export const FavoriteItem: React.FC<FavoriteItemProps> = ({
  fsEntryId,
  folderName,
  onRemove,
  isRemoving,
  type,
  linkPath,
}) => {
  const { pathname } = useLocation();

  const handleRemove = () => {
    onRemove(fsEntryId);
  };

  const finalLinkPath = linkPath || `/drive/${fsEntryId}`;
  const isCurrent = pathname === finalLinkPath;

  return (
    <div className="group relative">
      <Link
        to={finalLinkPath}
        className={clsx("flex items-center gap-2 rounded-md px-2 py-1.5 transition-colors duration-200 ease-in-out", {
          "bg-ui-sidebar-text text-white": isCurrent,
          "text-atriablue-500 hover:bg-white hover:text-gray-600": !isCurrent,
          "pointer-events-none opacity-50": isRemoving,
        })}
      >
        {type === "folder" ? (
          <FolderIcon className="h-5 w-5 shrink-0" aria-hidden={true} />
        ) : (
          <ClipboardListIcon className="h-5 w-5 shrink-0" aria-hidden={true} />
        )}

        <span className="flex-1 text-sm" title={folderName}>
          {folderName}
        </span>
      </Link>
      <Button
        variant="ghost"
        type="button"
        size="sm"
        className="absolute right-1 top-1/2 h-6 w-6 -translate-y-1/2 transform p-0 opacity-0 transition-opacity group-hover:opacity-100"
        onClick={handleRemove}
        disabled={isRemoving}
        title="Remove from favorites"
      >
        <XIcon className="h-3 w-3 text-gray-500 hover:text-red-500" />
      </Button>
    </div>
  );
};
